import styled from 'styled-components';
import logo from '../assets/logo/RJ_192.png';
import { RJGrueso } from '../assets/icons';
import { getFontSize } from '../utils/getFont';

const StyledFlex = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  align-items: ${({ alignItems }) => alignItems || 'stretch'};
  gap: ${({ gap }) => gap || '0'};
  width: ${({ width }) => width || '100%'};
  min-width: fit-content;
`;

export const Flex = ({ children, ...props }) => {
  return <StyledFlex {...props}>{children}</StyledFlex>;
};
